<template>

    <div class="container-fluid">
        <div class="row">
            <div class="col-6">

            </div>
            <div class="col-6">
                <ol style="float: right;" class="breadcrumb ">
                    <a v-show="opcrud > 0" @click.prevent="mtdcancelaredicao()"
                        class="btn btn-info btn-sm button-voltar"><i class="fa fa-arrow-alt-circle-left"></i>
                        Voltar</a>

                    <li style="padding-left: 15px;" class="breadcrumb-item"><a href="/inicio">Início</a></li>
                    <li class="breadcrumb-item"><a @click.prevent="mtdcancelaredicao()">R. de Ponto</a></li>
                    <li class="breadcrumb-item active">{{ descop.toLocaleLowerCase() }}</li>
                </ol>
            </div>

        </div>
        <div id="pnlista">
            <!-- Botão Novo empresa -->
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-12">
                            <a @click.prevent="mtdnovo()" class="btn btn-info">
                                <i class="bi bi-person-plus"></i> Novo registro
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Pesquisa empresa  -->
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="edtipopesq">Por</label>
                                <select class="form-select form-control" v-model="pfiltro"
                                    aria-label="Default select example">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label for="">Pesquisa</label>
                                <input type="text" v-model="pconteudo" class="form-control" id="nome" required="">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Período</label>
                                <select class="form-select form-control" v-model="pperiodo"
                                    aria-label="Default select example">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2" v-show="pperiodo == 1">
                            <div class="form-group">
                                <label for="">Data Início</label>
                                <input type="date" v-model="pdatainicio" class="form-control">
                            </div>
                        </div>
                        <div class="col-lg-2" v-show="pperiodo == 1">
                            <div class="form-group">
                                <label for="">Data Fim</label>
                                <input type="date" v-model="pdatafim" class="form-control">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Período Hora</label>
                                <select class="form-select form-control" v-model="pperiodohora"
                                    aria-label="Default select example">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2" v-show="pperiodohora == 1">
                            <div class="form-group">
                                <label for="">Hora Início</label>
                                <input type="time" v-model="phorainicio" class="form-control">
                            </div>
                        </div>
                        <div class="col-lg-2" v-show="pperiodohora == 1">
                            <div class="form-group">
                                <label for="">Hora Fim</label>
                                <input type="time" v-model="phorafim" class="form-control">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Limite</label>
                                <select class="form-select form-control" v-model="pqtdregistros"
                                    aria-label="Default select example">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                    <option value="1000">1000</option>
                                    <option value="99999999">Todos</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2" style="padding-top: 25px;">
                            <a @click.prevent="mtdexecutapesquisa()" style="width: 100%;" class="btn btn-info">
                                <i class="bi bi-search"></i> Listar
                            </a>
                        </div>
                    </div>
                </div> 
            </div>

            <!-- Tabela de empresas -->
            <div class="card">
                <div class="card-body">
                    <!-- Tabela de empresas com EasyDataTable -->
                    <EasyDataTable :headers="headers" :items="lstbatidas" :pagination="false" hide-footer
                        empty-message="Nenhum dado encontrado"
                        table-class-name="table table-hover text-nowrap table-bordered table-striped">
                        <template #item-acoes="{ id,  }">
                            <div style="display: flex; justify-content: center;">
                                <button type="button" class="btn btn-sm btn-warning" @click="mtdajuste(id)">
                                    <i class="bi bi-eraser"></i>
                                </button>

                                <button style="margin-left: 15px;" type="button" class="btn btn-sm btn-info"
                                    @click="abrirMapa(id)">
                                    <i class="bi bi-map"></i>
                                </button>

                                <button type="button" style="margin-left: 15px;" class="btn btn-sm btn-warning" @click="mtdimprimecomprovante(id)">
                                    <i class="bi bi-printer"></i>
                                </button>


                                
                            </div>
                        </template>

                        <template #item-nome="{ tipo, nome }">
                            {{ nome }}
                        </template>


                        <template #item-tipo="{ tipo }">
                            <div style="display: flex; justify-content: center;">
                                <span v-if="tipo.toLowerCase() === 'entrada'" class="badge bg-success">
                                    <i class="bi bi-arrow-down-circle"></i> Entrada
                                </span>
                                <span v-else-if="tipo.toLowerCase() === 'saida'" class="badge bg-danger">
                                    <i class="bi bi-arrow-up-circle"></i> Saída
                                </span>
                                <span v-else-if="tipo.toLowerCase() === 'pausa'" class="badge bg-warning">
                                    <i class="bi bi-pause-circle"></i> Pausa
                                </span>
                                <span v-else-if="tipo.toLowerCase() === 'retorno'" class="badge bg-info">
                                    <i class="bi bi-arrow-clockwise"></i> Retorno
                                </span>
                                <span v-else class="badge bg-secondary">
                                    <i class="bi bi-question-circle"></i> Desconhecido
                                </span>
                            </div>
                        </template>

                    </EasyDataTable>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            
                            <div class="col-12">
                                <vue-awesome-paginate :total-items="pqtd_total_registros" :items-per-page="pqtdregistros"
                                    :max-pages-shown="2" v-model="pagina_atual"  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="pncadastro">
            <!-- Cadastro de empresas -->
            <div class="card">
                <div class="card-body">
                    <div class="container">
                        <div class="row">
                            
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <label for="edid">Código</label>
                                    <input type="text" v-model="vid" class="form-control" id="edid" disabled>
                                </div>
                            </div>
                            
                            <div class="col-sm-12 col-md-10 col-lg-10">
                                <span class="lblselect2">Filial/Empresa:</span>
                                <select id="cbempresa" data-placeholder="Selecione uma opção" :disabled="ativadesativa" data-allow-clear="true"
                                    style="width:100%;" v-model="vidempresa">
                                </select>
                            </div>

                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Colaborador:</span>
                                <select id="cbcolaborador" data-placeholder="Selecione uma opção" :disabled="ativadesativa" data-allow-clear="true"
                                    style="width:100%;" v-model="vidcolaborador">
                                </select>
                            </div>

                            <div class="col-lg-2">
                                <div class="form-group">
                                    <label for="edtipo">Tipo:</label>
                                    <select v-model="vtipo" class="form-select" :disabled="ativadesativa" id="edtipo">
                                        <option value="entrada">Entrada</option>
                                        <option value="pausa">Pausa</option>
                                        <option value="retorno">Retorno</option>
                                        <option value="saida">Saída</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-lg-2">
                                <div class="form-group">
                                    <label for="edcomportamento">Comportamento:</label>
                                    <select v-model="vcomportamento" class="form-select" disabled id="edcomportamento">
                                        <option value="0">Original</option>
                                        <option value="1">Manual</option>
                                        <option value="2">Correção</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-lg-2">
                                <div class="form-group">
                                    <label for="">Data da batida</label>
                                    <input type="date" v-model="vdatabatida" :disabled="ativadesativa" class="form-control">
                                </div>
                            </div>

                            <div class="col-lg-2" >
                                <div class="form-group">
                                    <label for="">Hora da batida</label>
                                    <input type="time" v-model="vhorabatida" :disabled="ativadesativa" class="form-control">
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <div class="form-group">
                                    <label for="edobs">Observação</label>
                                    <textarea v-model="vobs" class="form-control" id="edobs" :disabled="ativadesativa" rows="3"></textarea>
                                </div>
                            </div>    

                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 col-md-10 col-sm-12">

                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-12">
                                <button v-show="opcrud == 1" :disabled="validou" @click.prevent="mtdgravar()" style="width: 100%;" id="btgravar"
                                    class="btn btn-info">
                                    <i class="bi bi-edit"></i> Gravar
                                </button>
                                <button v-show="opcrud == 2" :disabled="validou" @click.prevent="mtdgravar()" style="width: 100%;" id="btgravar"
                                    class="btn btn-warning">
                                    <i class="bi bi-edit"></i> Alterar
                                </button>
                                <button v-show="opcrud == 3" :disabled="validou" @click.prevent="mtdgravar()" style="width: 100%;" id="btgravar"
                                    class="btn btn-danger">
                                    <i class="bi bi-edit"></i> Excluir
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Mapa -->
        <div class="modal fade"  ref="modalMapa" tabindex="-1" aria-labelledby="modalMapaLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalMapaLabel">Localização</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div id="mapa" style="width: 100%; height: 400px;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
// @ is an alias to /src

//Eu sou o caminho, a verdade e a vida. Ninguém vem ao Pai senão por mim. (João 14:6); ☧


import Swal from 'sweetalert2'
import util from '../util.js'
import EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import router from '@/router/index.js';
import { Modal } from "bootstrap";


import { ref } from "vue";


const onClickHandler = (page) => {
  console.log(page);
};

const pagina_atual = ref(1);



export default {
    name: 'registroponto',

    data() {
        return {

            //variaveis do cadastro 
            opcrud: 0,
            vid: 0,

            vidanterior    : '',
          
            vidempresa     : null,
            vidcolaborador : null,
            vtipo          : 'entrada',
            vcomportamento : '0',
            vdatabatida    : '',
            vhorabatida    : '',
            vobs           : '',
            

            modulo: 'REGISTRO DE PONTO',
            descop: '',

            //paginação
            pqtd_total_registros: 10,
            pagina_atual        : 1,
            pqtdregistros       : 10,
            pqtd_paginas        : 0,


            //filtros
            pfiltro             : 1,
            pconteudo           : '',

            pperiodo            : 0,
            pdatainicio         : '',
            pdatafim            : '',

            pperiodohora        : 0,
            phorainicio         : '',    
            phorafim            : '',

            ativadesativa       : false,

            headers: [
                { text: 'Ações',  value: 'acoes',            sortable: false, width: 80 },
                { text: 'Cód',    value: 'id',               sortable: true, width: 80 },
                { text: 'Nome',   value: 'colaborador_nome', sortable: true },
                { text: 'Filial', value: 'filial_nome',      sortable: true },
                { text: 'Data',   value: 'data',             sortable: true },
                { text: 'Hora',   value: 'hora',             sortable: true },
                { text: 'Tipo',   value: 'tipo',             sortable: false },
            ],

            map      : null,
            marker   : null,
            latitude : -23.5505, // Exemplo
            longitude: -46.6333, // Exemplo

            ModalMenu: null,

            lstbatidas: []

        }
    },
    components: {
        EasyDataTable,
    },

    methods: {
        mtdajuste(id)  {   
        
            this.descop = 'AJUSTE'

            this.ativadesativa = false;
            this.mtdpreparacrud(1);
            this.mtdlocalizaregistro(id);
            this.vidanterior    = id;


            this.vid            = '';
            this.vcomportamento = 2;
            

        },
        mtdimprimecomprovante(id)  {   
            const vself = this;
            
            // Define o arquivo base
            const urlBase = util.servidor +'/controller/registrosdeponto.php'; 

            // Monta o objeto de parâmetros
            const params = {
                op: 'imprimircomprovante',
                idempresa: vself.$store.state.usuario.idempresa,
                idbatida : id,
            };

            // Converte o objeto em uma string de consulta (Query String)
            const queryString = new URLSearchParams(params).toString();

            // Abre em uma nova aba (_blank)
            window.open(`${urlBase}?${queryString}`, '_blank');
        },
        async abrirMapa(id) {

            await this.mtdlocalizaregistro(id);

            this.ModalMenu = new Modal(this.$refs.modalMapa);

            // 1. Abre o modal do Bootstrap
            this.ModalMenu.show();

            // 2. Espera o modal estar visível para desenhar o mapa
            setTimeout(() => {
                this.renderizarMapa();
            }, 2000);
        },

        renderizarMapa() {
            // Se o mapa já existir, apenas remove e cria de novo ou atualiza a visão
            if (this.map) {
                this.map.remove();
            }

            // Cria o mapa focando na latitude e longitude
            this.map = L.map('mapa').setView([this.latitude, this.longitude], 15);

            // Adiciona as "telhas" (tiles) do OpenStreetMap
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '© OpenStreetMap contributors'
            }).addTo(this.map);

            // Adiciona o marcador vermelho no ponto exato
            this.marker = L.marker([this.latitude, this.longitude]).addTo(this.map)
                .bindPopup('Localização do Registro')
                .openPopup();
        },
        mtdfiltropesquisa() {
            let rfiltro = '';
            if (parseInt(this.pfiltro) === 0) {
                rfiltro = this.pconteudo === '' ? '' : ' and r.id=' + this.pconteudo;
            } else {
                rfiltro = this.pconteudo === '' ? '' : ' and r.upper(nome) like upper("' + this.pconteudo + '%")';
            }
            return rfiltro;
        },
        mtdexecutapesquisa() {
            var vself = this;
            let filtro = vself.mtdfiltropesquisa();
            this.pagina_atual = 1;
            let parametros = [
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op',        valor: 'qtdregistros' },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro',    valor: filtro }
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/registrosdeponto.php');
            retorno.then(function (response) {
                vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                let qtdpg = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                vself.pqtd_paginas = qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregaitem(1);
            }).catch(function (response) {
                //alert('Erro ao consultar registros');
            });
        },
        mtdcarregaitem(ipagina) {
            let vself = this;
            let filtro = vself.mtdfiltropesquisa();
            vself.$loading.show();
            let parametros = [
                { parametro: 'op',        valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro',    valor: filtro },
                { parametro: 'limit',     valor: vself.pqtdregistros },
                { parametro: 'offset',    valor: (parseInt(ipagina) - 1) * parseInt(vself.pqtdregistros) },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/registrosdeponto.php');
            retorno.then(function (response) {
                vself.lstbatidas = JSON.parse(JSON.stringify(response.data));
                vself.$loading.hide();
            }).catch(function (response) {
                vself.lstbatidas = [];
                vself.$loading.hide();
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;

        },
        resetarDados() {
            this.vid            = '';
            this.vidempresa     = null,
            this.vidcolaborador = null,
            this.vtipo          = 'entrada';
            this.vcomportamento = '0';
            this.vdatabatida    = '';
            this.vhorabatida    = '';
            this.vobs           = '';
            this.vidanterior    = '';

            $('#cbempresa').val(null).trigger('change');
            $('#cbcolaborador').val(null).trigger('change');
 
     
        },
        mtddefault() {
            $('#pnlista').hide();
            this.resetarDados();
            $('#pncadastro').fadeIn(700);
            this.$nextTick(function () {
                if (parseInt(this.opcrud) < 3) {
                    $('#eddescricao').focus();
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;
            this.mtddefault();
        },
        mtdnovo() {


            this.descop = 'INCLUSÃO'
            this.ativadesativa  = false;
            this.mtdpreparacrud(1);
            this.vcomportamento = 1

        },
        mtdcancelaredicao() {
            this.descop = ''
            this.opcrud = 0;
            $('#pncadastro').hide();
            $('#pnlista').fadeIn(700);
            $('#edconteudopesq').focus();

        },

        mtdgravar() {
            let vself = this;
            Swal.fire({
                title: "Confirmação",
                text: 'Confirma ' + vself.descop + ' DE ' + vself.modulo + '?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).
                then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.mtdregistro();
                    } else {
                        $('#btgravar').focus();
                    }
                });
        },
        mtdlocalizaregistro(id) {
            var vself = this;
            let filtro = ' and r.id=' + id;
            let parametros = [
                { parametro: 'op',        valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro',    valor: filtro },
                { parametro: 'limit',     valor: 1 },
                { parametro: 'offset',    valor: 0 },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/registrosdeponto.php');
            retorno.then(function (response) {
                vself.mtdigualarcampos(response.data[0]);
                if (parseInt(vself.opcrud) < 3) {
                    $('#eddescricao').focus();
                } else {
                    $('#btgravar').focus();
                }
            }).catch(function (response) {

            });
        },
        mtdalterar(id) {

            this.descop = 'ALTERAÇÃO'

            this.ativadesativa = false;
            this.mtdpreparacrud(2);
            this.mtdlocalizaregistro(id);

        },
        mtdexcluir(id) {

            this.descop = 'EXCLUSÃO'

            this.ativadesativa = true;
            this.mtdpreparacrud(3);
            this.mtdlocalizaregistro(id);

        },
        mtdigualarcampos(registro) {
            
            this.vid              = registro.id;     
            this.vidanterior      = registro.id;
            this.vtipo            = registro.tipo;
            
            this.vdatabatida      = registro.data;
            this.vhorabatida      = registro.hora;
            this.vobs             = registro.obs;
            
            this.latitude         = parseFloat(registro.latitude);
            this.longitude        = parseFloat(registro.longitude);

            this.vidempresa       = registro.idempresa;
            let defempresa        = new Option(registro.filial_nome, registro.idempresa, true, true);
            $('#cbempresa').append(defempresa).trigger('change');

            this.vidcolaborador   = registro.iduser;
            let defcolaborador    = new Option(registro.colaborador_nome, registro.iduser, true, true);
            $('#cbcolaborador').append(defcolaborador).trigger('change');

   
        },
        mtdregistro() {
            let vself = this;
            let registrocrud = {
                'id'            : this.vid,
                'idempresa'     : this.vidempresa,
                'idcolaborador' : this.vidcolaborador,
                'idanterior'    : this.vidanterior,
                'tipo'          : this.vtipo,
                'comportamento' : this.vcomportamento,
                'databatida'    : this.vdatabatida, 
                'horabatida'    : this.vhorabatida, 
                'obs'           : this.vobs,
            };
            let parametros = [
                { parametro: 'op',         valor: 'rotinacrud' },
                { parametro: 'opcrud',     valor: vself.opcrud },
                { parametro: 'idempresa',  valor: vself.$store.state.usuario.idempresa },
                { parametro: 'registro',   valor: JSON.stringify(registrocrud) },
                { parametro: 'idusuario',  valor: vself.$store.state.usuario.idusuario },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/registrosdeponto.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data)) {
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                    vself.pfiltro = 0;
                    vself.pconteudo = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                    vself.pqtd_paginas = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarregaitem(1);
                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
            });
        },

    },
    computed:{
        validou(){
            return this.vnome == ''

        }
    },
    mounted() {

        let vself = this;

        $loading.show()
        setTimeout(() => {

            this.$loading.hide()
            this.mtdexecutapesquisa();
        }
        , 1000)
        $('#pncadastro').hide();


        $("#cbempresa").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbfiliais ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidempresa = $("#cbempresa").val();
        });
        
        $("#cbcolaborador").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbcolaboradores ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidcolaborador = $("#cbcolaborador").val();
        });
    },
    watch:{
        pagina_atual(val){
            this.mtdcarregaitem(val)
        }
    }
}
</script>
<style>

.pagination-container {
    display: flex;

    column-gap: 10px;
  }

  .paginate-buttons {
  

    border-radius: 20px;

    display: flex;

    cursor: pointer;

    background-color: rgb(242, 242, 242);

    border: 1px solid rgb(217, 217, 217);

    font-size: small;

    color: black;
  }

  .paginate-buttons:hover {
    background-color: #d8d8d8;
  }

  .active-page {
    background-color: #393193;

    border: 1px solid #393193;

    color: white;
  }

  .active-page:hover {
    background-color: #393193;
  }

</style>